import React, { useState, useEffect } from 'react';
import CvTemplate from './CvTemplate';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import { useDropzone } from 'react-dropzone';
import { X } from 'react-feather';
import { toast } from 'react-toastify';
import FileUploadDisplay from '../../components/FileUploadDisplay';

// Set pdf.worker.min.js path to public folder (copy pdf.worker.min.js into public/)
pdfjsLib.GlobalWorkerOptions.workerSrc = process.env.PUBLIC_URL + '/pdf.worker.min.js';
const BASE_URL = window.location.hostname === 'localhost' ? "http://localhost:8000" : "https://dlqw5ngx5xpnk.cloudfront.net";

const UploadDocument = ({ onFileSelect, initialFile, onParsedData }) => {
    // Loader overlay styles
    const loaderStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(255,255,255,0.7)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '2rem',
        color: '#eea513ff',
    };
    const [currentFile, setCurrentFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);




    const parsePdfAndLog = async (file) => {
        try {
            setIsLoading(true);
            const arrayBuffer = await file.arrayBuffer();
            const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

            let textContent = "";
            for (let i = 1; i <= pdf.numPages; i++) {
                const page = await pdf.getPage(i);
                const content = await page.getTextContent();
                textContent += content.items.map((item) => item.str).join(" ") + "\n";
            }
            // console.log("Full text extracted:", textContent);

            // Send extracted text to backend API for OpenAI parsing
            const response = await fetch(`${BASE_URL}/api/parseresume`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ resumeText: textContent })
            });

            const data = await response.json();

            if (onParsedData) onParsedData(data);
        } catch (err) {
            console.error("Error parsing PDF or calling OpenAI:", err);
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        if (initialFile && currentFile !== initialFile) {
            if (initialFile instanceof File) {
                setCurrentFile(initialFile);
            } else if (typeof initialFile === 'string') {
                setCurrentFile(initialFile);
            } else if (initialFile && typeof initialFile === 'object') {
                if (initialFile.url) {
                    setCurrentFile(initialFile.url);
                } else if (initialFile.data) {
                    const file = new File(
                        [initialFile.data],
                        initialFile.name || 'resume.pdf',
                        { type: 'application/pdf' }
                    );
                    setCurrentFile(file);
                }
            }
        }
        if (!initialFile && currentFile) {
            setCurrentFile(null);
        }
        // eslint-disable-next-line
    }, [initialFile]);

    const {
        isDragActive,
        isDragAccept,
        isDragReject,
        getRootProps,
        getInputProps
    } = useDropzone({
        accept: {
            'application/pdf': []
        },
        maxFiles: 1,
        onDrop: (acceptedFiles) => {
            // Only allow files <= 5MB
            const validFiles = acceptedFiles.filter(file => file.size <= 5 * 1024 * 1024);
            if (validFiles.length === 0) {
                toast.error("File too large. Maximum allowed size is 5MB.");
                return;
            }
            const file = validFiles[0];
            setCurrentFile(file);
            if (onFileSelect) {
                onFileSelect(file);
            }
            // Parse PDF for resume data
            parsePdfAndLog(file);
            toast.success("Resume uploaded successfully");
        }
    });

    const handleRemoveFile = () => {
        setCurrentFile(null);
        if (onFileSelect) {
            onFileSelect(null);
        }
        if (onParsedData) {
            onParsedData(null);
        }
        toast.info("Resume removed");
    };

    const [showCvTemplate, setShowCvTemplate] = useState(false);

    return (
        <>
            {isLoading && (
                <div style={loaderStyle}>
                    <div>
                        <span className="spinner-border spinner-border-lg" role="status" aria-hidden="true"></span>
                        {/* <div style={{ marginTop: 20 }}>Parsing resume, please wait...</div> */}
                    </div>
                </div>
            )}
            <div className="dropzone">
                <div {...getRootProps({ className: 'dropzone-upload-wrapper' })} style={{ cursor: 'pointer' }}>
                    <input {...getInputProps()} />
                    <div className="dropzone-inner-wrapper">
                        {isDragAccept && (
                            <div className="font-size-sm text-success">PDF file accepted!</div>
                        )}
                        {isDragReject && (
                            <div>
                                <div className="d-100 btn-icon mb-3 hover-scale-lg bg-danger shadow-danger-sm rounded-circle text-white">
                                    <X className="d-60" />
                                </div>
                                <div className="font-size-sm text-danger">
                                    Only PDF files are allowed!
                                </div>
                            </div>
                        )}
                        {!isDragActive && (
                            <div className="upload_detail text-center">
                                <div style={{ width: 38, height: 38, margin: '0 auto 10px' }}>
                                    <img
                                        src="/assets/images/upload.svg"
                                        alt="Upload"
                                        style={{ width: 32, height: 32, marginBottom: 10 }}
                                    />
                                </div>
                                <h4>Upload Your Resume</h4>
                                <h5>Please upload your resume in PDF format (max 5MB)</h5>
                                <h6
                                    style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}
                                    onClick={e => {
                                        e.stopPropagation();
                                        setShowCvTemplate(true);
                                    }}
                                >
                                    <i className="bi bi-info-circle"></i> CV Template
                                </h6>
                            </div>
                        )}

                    </div>
                </div>
            </div>

            {showCvTemplate && <CvTemplate onClose={() => setShowCvTemplate(false)} />}
            {currentFile && (
                <div className="mt-3">
                    <FileUploadDisplay
                        file={currentFile}
                        onRemove={handleRemoveFile}
                        showDownload={true}
                        showView={true}
                        showRemove={true}
                    />
                </div>
            )}
        </>
    );
};

export default UploadDocument;
